import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
    deleteItemID,
    deleteItemIdSuccess,
    editItemId,
    getItemList,
    getItemListSuccess,
    SaveItemMasterActionSuccess,
    updateItemMasterActionSuccess,
} from "../../../../store/Administrator/ItemsRedux/action";
import ItemsMaster from "../ItemMaster/itemIndex";
import CommonListPage from "../../../../components/Common/CommonMasterListPage";
import { commonPageFieldList, commonPageFieldListSuccess, } from "../../../../store/actions";
import { ITEM } from "../../../../routes/route_url";
import * as pageId from "../../../../routes/allPageID"
import { PageLoadingSpinner } from "../../../../components/Common/CommonButton";
import { mobileApp_ProductAdd_Api, mobileApp_ProductDelete_Api, mobileApp_ProductUpdate_Api } from "../../../../helpers/backend_helper";
import { showToastAlert } from "../../../../helpers/axios_Config";
import { isMobileAppApiEnabledForCompany, loginCompanyID, loginSystemSetting } from "../../../../components/Common/CommonFunction";
import * as _act from "../../../../store/actions";

const ItemsList = () => {

    const dispatch = useDispatch();
    const reducers = useSelector(
        (state) => ({
            listBtnLoading: state.ItemMastersReducer.listBtnLoading,
            GoBtnlistloading: state.ItemMastersReducer.loading,
            tableList: state.ItemMastersReducer.ItemList,
            editData: state.ItemMastersReducer.editData,
            updateMsg: state.ItemMastersReducer.updateMsg, 
            deleteMsg: state.ItemMastersReducer.deleteMsg,
            userAccess: state.Login.RoleAccessUpdateData,
            postMsg: state.ItemMastersReducer.postMsg,
            pageField: state.CommonPageFieldReducer.pageFieldList,
        })
    );

    const action = {
        getList: getItemList,
        editId: editItemId,
        deleteId: deleteItemID,
        postSucc: SaveItemMasterActionSuccess,
        updateSucc: updateItemMasterActionSuccess,
        deleteSucc: deleteItemIdSuccess
    }

    //  This UseEffect => Featch Modules List data  First Rendering
    useEffect(() => {
        dispatch(commonPageFieldListSuccess(null))
        dispatch(commonPageFieldList(pageId.ITEM_lIST))
        dispatch(getItemList());
        return () => {
            dispatch(getItemListSuccess([]));
        }
    }, []);


    const mobaileDeleteApiFinc = async (deleteMsg) => {
        
        //***************mobail app api*********************** */
        let mobilApiResp;
        if (isMobileAppApiEnabledForCompany()) {
            mobilApiResp = await mobileApp_ProductDelete_Api(deleteMsg.TransactionID)
            if (mobilApiResp?.StatusCode === 200) { showToastAlert(mobilApiResp.Message, "success") }
            //************************************** */

            return // *note  return required 
        }
    }

    const { pageField, GoBtnlistloading } = reducers

    const sendFunc = async (row) => {
        dispatch(_act.ActionLoad({ btnId: row?.btnId }));
    
        if (!row || !row.rowData || !row.rowData.id) {
            showToastAlert("Item ID not found", "error");
            dispatch(_act.ActionLoadStop({ btnId: row?.btnId })); // ✅ STOP loader
            return;
        }
        
        const itemId = row.rowData.id;
        if (!isMobileAppApiEnabledForCompany()) {
            showToastAlert("Mobile API Disabled", "error");
            dispatch(_act.ActionLoadStop({ btnId: row?.btnId })); // ✅ STOP loader
            return;
        }
        try {
            // ✅ ONLY ADD API
            const mobilApiResp = await mobileApp_ProductAdd_Api(itemId);
    
            if (mobilApiResp?.StatusCode === 200) {
                showToastAlert(mobilApiResp.Message || "Item added to mobile successfully", "success");
            } else {
                const apiMsg = mobilApiResp?.Message?.message || mobilApiResp?.Message;
                showToastAlert(apiMsg || "Failed to add item to mobile", "error");
            }
    
        } catch (error) {
            console.error("Mobile push failed:", error);
            showToastAlert("Mobile push failed", "error");
        } finally {
            dispatch(_act.ActionLoadStop({ btnId: row?.btnId })); // ✅ ALWAYS stops loader
        }
    };
    


    return (
        <React.Fragment>
            <PageLoadingSpinner isLoading={(GoBtnlistloading || !pageField)} />
            {
                (pageField) &&
                <CommonListPage
                    action={action}
                    reducers={reducers}
                    MasterModal={ItemsMaster}
                    masterPath={ITEM}
                    mobaileDeleteApiFinc={mobaileDeleteApiFinc}
                    sendFunc={sendFunc}
                    ButtonMsgLable={"Item"}
                    deleteName={"Name"}
                />

            }

        </React.Fragment>
    )
}

export default ItemsList;
